import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ViewAsBanner = () => {
  const { userType } = useAuth();
  const navigate = useNavigate();

  const viewAs = JSON.parse(localStorage.getItem('viewAs') || 'null');

  if (userType !== 'super_admin' || !viewAs) {
    return null;
  }

  const handleExit = () => {
    localStorage.removeItem('viewAs');
    navigate('/super-admin');
    window.location.reload();
  };

  const viewLabel = viewAs.viewType === 'admin' ? 'Admin View' : 'Volunteer View';

  return (
    <div className="bg-amber-400 text-amber-900 px-4 py-2 flex items-center justify-between text-sm font-medium z-50 flex-shrink-0">
      <span>
        Viewing as <strong>{viewAs.orgName}</strong> — {viewLabel}
      </span>
      <button
        onClick={handleExit}
        className="ml-4 bg-warning-700 hover:bg-warning-800 text-white px-3 py-1 rounded text-xs font-medium transition-colors"
      >
        Exit to Super Admin
      </button>
    </div>
  );
};

export default ViewAsBanner;
